var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.s.dropZone},[_c('div',{class:_vm.s.dropZoneContainer},[_c('span',{class:_vm.s.dropZoneTitle},[_vm._v("Доступен выбор только одного файла."),_c('br'),_vm._v("Удалите выбранный файл, если хотите загрузить другой.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }